import HeaderTable from '@/fsd/shared/ui/HeaderTable/HeaderTable';
import HeaderTableItem from '@/fsd/shared/ui/HeaderTableItem';
import { observer } from 'mobx-react-lite';
import { mutualSettlementsStore } from '../../model/store/MutualSettlementsStore';
import styles from '../MutualSettlements/MutualSettlements.module.scss';
import { getSortStatus } from '@/fsd/shared/lib/helpers/getSortStatus/getSortStatus';
import { IMutualSettlementsSortFields } from '@/fsd/entities/mutualSettlements/model/IMutualSettlementsSortFields';

interface IProps {
  sorted: string[];
  handleSortChange: (field: IMutualSettlementsSortFields) => void;
}

const MutualSettlementsTableHeader = observer(
  ({ sorted, handleSortChange }: IProps) => {
    return (
      <HeaderTable
        items="mutual-settlements"
        additionalClass="blueHeader"
        fixed={true}
      >
        {mutualSettlementsStore.checkIfColumnIsVisible('id') && (
          <>
            <HeaderTableItem name="ID" className={styles.columnId} />
            <HeaderTableItem additionalClass="divider" />
          </>
        )}
        {mutualSettlementsStore.checkIfColumnIsVisible('date') && (
          <>
            <HeaderTableItem name="Дата" className={styles.columnDate} />
            <HeaderTableItem additionalClass="divider" />
          </>
        )}
        {mutualSettlementsStore.checkIfColumnIsVisible('organisation') && (
          <>
            <HeaderTableItem
              name="Организация"
              className={styles.columnOrganisation}
            />
            <HeaderTableItem additionalClass="divider" />
          </>
        )}
        {mutualSettlementsStore.checkIfColumnIsVisible('counterparty') && (
          <>
            <HeaderTableItem
              name="Контрагент"
              className={styles.columnCounterparty}
            />
            <HeaderTableItem additionalClass="divider" />
          </>
        )}
        {mutualSettlementsStore.checkIfColumnIsVisible('start_period') && (
          <>
            <HeaderTableItem
              name="На начало"
              className={styles.columnStartPeriod}
              sortable
              sortStatus={getSortStatus(sorted, 'opening_balance')}
              onSortClick={() => handleSortChange('opening_balance')}
            />
            <HeaderTableItem additionalClass="divider" />
          </>
        )}
        {mutualSettlementsStore.checkIfColumnIsVisible('paid') && (
          <>
            <HeaderTableItem
              name="Оплачено"
              className={styles.columnPaid}
              sortable
              sortStatus={getSortStatus(sorted, 'paid_total')}
              onSortClick={() => handleSortChange('paid_total')}
            />
            <HeaderTableItem additionalClass="divider" />
          </>
        )}
        {mutualSettlementsStore.checkIfColumnIsVisible('accepted') && (
          <>
            <HeaderTableItem
              name="Принято"
              className={styles.columnAccepted}
              sortable
              sortStatus={getSortStatus(sorted, 'accrued_total')}
              onSortClick={() => handleSortChange('accrued_total')}
            />
            <HeaderTableItem additionalClass="divider" />
          </>
        )}
        {mutualSettlementsStore.checkIfColumnIsVisible('end_period') && (
          <>
            <HeaderTableItem
              name="На конец"
              className={styles.columnEndPeriod}
              sortable
              sortStatus={getSortStatus(sorted, 'closing_balance')}
              onSortClick={() => handleSortChange('closing_balance')}
            />
            <HeaderTableItem additionalClass="divider" />
          </>
        )}
        {mutualSettlementsStore.checkIfColumnIsVisible('status') && (
          <>
            <HeaderTableItem name="Статус" className={styles.columnStatus} />
          </>
        )}
      </HeaderTable>
    );
  }
);

export default MutualSettlementsTableHeader;
